const Logo = ({ fontSize }) => {
  return <h1 className={"font-logo tracking-[6px] " + fontSize}>Vivid</h1>;
};

export { Logo };
